import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TechnologyStackState } from '../reducers/technologystack.reducer';

export const technologystackState: any = createFeatureSelector<TechnologyStackState>('tecnologyStack');

export const technologystackData = createSelector(technologystackState, (state: any) => {
  return state.technologyStackData;
});

export const appMetaInfoData = createSelector(technologystackState, (state: any) => {
  return state.metaInfoData;
});

export const sharedDbs = createSelector(technologystackState, (state: any) => {
  return state.sharedDbs;
});

export const memberApps = createSelector(technologystackState, (state: any) => {
  return state.memberApps;
});

export const appSettingsData = createSelector(technologystackState, (state: any) => {
  return state.settingsData;
});
export const environmentDataList = createSelector(technologystackState, (state: any) => {
  return state.environmentDataList;
});

export const deletedEnvironmentId = createSelector(technologystackState, (state: any) => {
  return state.envId;
});

export const deleteEnvironmentsFailureSelector = createSelector(technologystackState, (state: any) => {
  return state.deleteEnvironmentsFailure;
});
export const saveEnvironmentsSuccessSelector = createSelector(
  technologystackState,
  (state: any) => state.saveEnvironmentsSuccess
);

export const saveEnvironmentsFailureSelector = createSelector(
  technologystackState,
  (state: any) => state.saveEnvironmentsFailure
);
